import React, { useEffect, useState } from 'react'
import { Table, Input, Row, Col, Tag } from 'antd'
import { FileTextOutlined } from '@ant-design/icons'

import axiosInstance from '../../Utils/axiosInstance'
import { GetTodayOnlineBooking } from "../../API's/AdminApi"
import { toast } from 'react-toastify'

export default function TodayOnlineBooking() {
  const [data, setData] = useState([])
  const [searchText, setSearchText] = useState('')
  const [tableLoading, setTableLoading] = useState(false)
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 5,
  })

  // ---------------- GET DATA ----------------
  const getTodayBookings = async () => {
    try {
      setTableLoading(true)

      const res = await axiosInstance.get(GetTodayOnlineBooking)

      setData(res.data || [])
    } catch (error) {
      toast.error('Failed to load bookings')
    } finally {
      setTableLoading(false)
    }
  }

  useEffect(() => {
    getTodayBookings()
  }, [])

  // ---------------- FORMAT DATE ----------------
    const formatDate = (date) => {
    if (!date) return '-'

    return new Date(date).toLocaleDateString('en-GB', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    })
  }

  // ---------------- FORMAT DATETIME ----------------
  const formatDateTime = (date) => {
    if (!date) return '-'

    return new Date(date).toLocaleString('en-IN')
  }

  // ---------------- GENDER ----------------
  const getGender = (gender) => {
    switch (gender) {
      case 1:
        return <Tag color="blue">Male</Tag>

      case 2:
        return <Tag color="pink">Female</Tag>

      default:
        return <Tag>Other</Tag>
    }
  }

  // ---------------- TABLE ----------------
  const columns = [
    {
      title: 'Sr No',
      render: (_, __, index) => index + 1,
    },

    {
      title: 'Member Name',
      dataIndex: 'name',
    },

    {
      title: 'Mobile No',
      dataIndex: 'mobileNo',
    },

    {
      title: 'Gender',
      dataIndex: 'gender',
      render: (gender) => getGender(gender),
    },

    {
      title: 'Birth Date',
      dataIndex: 'birthDate',
      render: (date) => formatDate(date),
    },

    {
      title: 'Amount',
      dataIndex: 'amount',
    },
  ]

  // ---------------- SEARCH ----------------
  const filteredData = data.filter(
    (item) =>
      item?.name?.toLowerCase().includes(searchText.toLowerCase()) ||
      item?.mobileNo?.includes(searchText),
  )

  const totalAmount = filteredData.reduce(
    (sum, item) => sum + Number(item.amount || 0),
    0,
  )

  return (
    <div className='p-4 page-background'>
      {/* HEADER */}
      <div className="page-header">
        <h2>
          <FileTextOutlined style={{ marginRight: 8 }} />
          Today's Online Booking
        </h2>
      </div>

      {/* SEARCH */}
      <Row gutter={16} className="pb-2 m-0">
        <Col xs={24} md={18}>
          {/* TOTAL AMOUNT */}
          <div
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              marginBottom: 16,
            }}
          >
            <div
              style={{
                background: '#f0f5ff',
                border: '1px solid #adc6ff',
                padding: '10px 18px',
                borderRadius: 8,
                fontSize: 16,
                fontWeight: 600,
                color: '#1d39c4',
              }}
            >
              Todays Total Amount: ₹{totalAmount}
            </div>
          </div>
        </Col>

        <Col xs={24} md={6} className="pt-2 pt-md-0">
          <Input
            placeholder="Search Member / mobile"
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
          />
        </Col>
      </Row>

      {/* TABLE */}
      <Table
        className="custom-table-header shadow"
        columns={columns}
        dataSource={filteredData}
        rowKey="id"
        bordered
        loading={tableLoading}
        style={{ overflowX: 'auto', backgroundColor: 'white' }}
        pagination={{
          showSizeChanger: true, // enable page size dropdown
          pageSizeOptions: ['5', '10', '20', '50'],
          showTotal: (total, range) =>
            `${range[0]}-${range[1]} of ${total} items`,
        }}
      />
    </div>
  )
}
